module.exports = __webpack_public_path__ + "static/media/img_logo.31ecf8d7.png";